function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Children, useMemo, useRef, useState } from 'react';
import { arrayOf, func, node, number, object, shape, string } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import SovosTabContent from "../sovos-tab-content/SovosTabContent";
import { findChildrenByType, filterOutChildrenByType } from "../internals/utils/reactHelpers";
import SovosHeroBanner from "../sovos-hero-banner/SovosHeroBanner";
import SovosGenericHeroBanner from "../sovos-generic-hero-banner/SovosGenericHeroBanner";
import sovosIconButtonElement from "../internals/prop-types/sovosIconButtonElement";
import PageTitleBar from "./components/PageTitleBar";
import TabBar from "./components/TabBar";
var Root = styled('div')(function (_ref) {
  var palette = _ref.theme.palette;
  return {
    backgroundColor: palette.background.default,
    display: 'flex',
    flex: '1 1 100%',
    flexDirection: 'column',
    height: '100vh',
    position: 'relative'
  };
});
var Header = styled('header')(function (_ref2) {
  var palette = _ref2.theme.palette;
  return {
    borderBottom: "1px solid ".concat(palette.divider)
  };
});
var ContentContainer = styled('div')({
  flex: '1 0 0',
  overflowX: 'auto',
  overflowY: 'scroll'
});
var SovosPageLayout = function SovosPageLayout(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    confirmTabChange = _ref3.confirmTabChange,
    dataTestId = _ref3['data-testid'],
    _ref3$initialSelected = _ref3.initialSelectedTabIndex,
    initialSelectedTabIndex = _ref3$initialSelected === void 0 ? 0 : _ref3$initialSelected,
    onTabChanged = _ref3.onTabChanged,
    style = _ref3.style,
    _ref3$pageCrumbs = _ref3.pageCrumbs,
    pageCrumbs = _ref3$pageCrumbs === void 0 ? [] : _ref3$pageCrumbs,
    pageTitle = _ref3.pageTitle,
    titleBarActions = _ref3.titleBarActions,
    titleIconButton = _ref3.titleIconButton;
  var _useState = useState(initialSelectedTabIndex),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var container = useRef(null);
  var onTabClick = function onTabClick(event, value) {
    var selectedTabProps = findChildrenByType(children, SovosTabContent)[value].props;
    if (confirmTabChange) {
      var confirmed = confirmTabChange(selectedTabProps.value || value);
      if (!confirmed) {
        return;
      }
    }
    setSelectedTab(value);
    if (onTabChanged) {
      onTabChanged(selectedTabProps.value || value);
    }
    if (selectedTabProps.onActive) {
      selectedTabProps.onActive();
    }
    if (container.current) {
      container.current.scrollTop = 0;
    }
  };
  var tabsData = useMemo(function () {
    var tabChildren = findChildrenByType(children, SovosTabContent);
    if (tabChildren.length) {
      return tabChildren.map(function (tab) {
        var thisTabProps = tab.props.TabProps || {};
        return {
          label: thisTabProps.label,
          icon: thisTabProps.icon
        };
      });
    }
    return null;
  }, [children]);
  var showTabs = (tabsData === null || tabsData === void 0 ? void 0 : tabsData.length) > 0;
  var renderHeroBanner = function renderHeroBanner() {
    return findChildrenByType(children, SovosHeroBanner, SovosGenericHeroBanner);
  };
  var renderContent = function renderContent() {
    var tabs = findChildrenByType(children, SovosTabContent);
    var otherChildren = filterOutChildrenByType(children, SovosTabContent, SovosHeroBanner, SovosGenericHeroBanner);
    if (tabs.length) {
      var tabContent = tabs.find(function (tab, index) {
        return index === selectedTab;
      });
      var tabChildren = Children.toArray(tabContent.props.children).concat(otherChildren);
      return /*#__PURE__*/React.cloneElement(tabContent, {
        children: tabChildren,
        selected: true
      });
    }
    return otherChildren;
  };
  return /*#__PURE__*/React.createElement(Root, {
    className: clsx('sovosPageLayout', className),
    "data-testid": dataTestId,
    style: style
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(PageTitleBar, {
    actions: titleBarActions,
    pageCrumbs: pageCrumbs,
    pageTitle: pageTitle,
    titleIconButton: titleIconButton
  }), showTabs && /*#__PURE__*/React.createElement(TabBar, {
    onTabClick: onTabClick,
    selectedTab: selectedTab,
    tabsData: tabsData
  }), renderHeroBanner()), /*#__PURE__*/React.createElement(ContentContainer, {
    ref: container
  }, renderContent()));
};
SovosPageLayout.propTypes = {
  /**
   * The content of the page layout. Should be wrapped with
   * `SovosPageContentGeneric`, `SovosPageContentTable`, or
   * `SovosPageContentTwoColumn`, which can in turn be wrapped with
   * `SovosTabContent`
   */
  children: node.isRequired,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Callback fired when tabs are clicked to confirm switching tabs
   */
  confirmTabChange: func,
  /**
   * @ignore
   */
  'data-testid': string,
  /**
   * Zero-based index of tab to be shown on page load
   */
  initialSelectedTabIndex: number,
  /**
   * Callback fired when tabs are clicked `function(selectedTab: object) => void`
   */
  onTabChanged: func,
  /**
   * Array of breadcrumb objects
   */
  pageCrumbs: arrayOf(shape({
    text: string.isRequired,
    onClick: func
  })),
  /**
   * String that displays the page title
   */
  pageTitle: string.isRequired,
  /**
   * Inline styles applied to the root element
   */
  style: object,
  /**
   * Node appended to a button group at the right of the page title bar
   */
  titleBarActions: node,
  /**
   * Icon button element
   */
  titleIconButton: sovosIconButtonElement
};
export default SovosPageLayout;